export default function verifyIfHasVinculed(err: string) {
  return err.includes('Failed to delete: This') && err.includes('is binded by');
}
